<template>
  <div class="maintenance-parts-list margin-top">
    <div class="notification is-success" role="alert" v-if="successMessage !== ''" v-html="successMessage"></div>
    <div class="notification is-danger" role="alert" v-if="errorMessage !== ''" v-html="errorMessage"></div>
    <div class="columns is-multiline">
      <div class="column is-6-tablet is-4-desktop" v-if="sealMaterials.length > 1">
        <div class="form-group">
          <label for="seal_material">Seal Material</label>
          <select v-model="sealMaterialFilter" id="seal_material">
            <option value="">Select a Seal Material</option>
            <option v-for="value in sealMaterials" :key="value" :value="value">{{ value }}</option>
          </select>
        </div>
      </div>
      <div class="column is-12" v-if="showProducts.length">
        <table cellpadding="5" cellspacing="0" class="products">
          <thead>
            <tr>
              <th>Product Name</th>
              <th>SKU</th>
              <th v-if="canPurchase">Price</th>
              <th v-if="canPurchase">Quantity</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="product in showProducts" :key="product.id" :data-product-id="product.id">
              <td class="description">
                <div class="description-content">
                  <img :src="product.marketing_image" width="100" v-if="product.marketing_image !== null" />
                  <span>{{ product.description }}</span>
                </div>
              </td>
              <td>{{ product.sku }}</td>
              <td v-if="canPurchase" class="price">
                <span v-if="product.available_online">${{ product.price }}</span>
                <span v-else class="not-available">Request a Quote</span>
              </td>
              <td v-if="canPurchase" class="quantity"><input type="number" v-model="quantities[product.id]" min="0" /></td>
            </tr>
          </tbody>
        </table>
        <div class="buttons">
          <div v-if="canPurchase"><button @click="addToCart()" class="btn-red" :disabled="!showAddToCart">Add to cart</button></div>
          <div><button @click="addToQuote()" class="btn-dark-grey" :disabled="!showAddToQuote">Add to Quote</button></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global products, seal_materials */

export default {
  name: 'MaintenancePartsList',
  data () {
    return {
      products: products,
      sealMaterials: seal_materials,
      sealMaterialFilter: '',
      showProducts: [],
      canPurchase: false,
      quantities: {},
      showAddToCart: false,
      showAddToQuote: false,
      successMessage: '',
      errorMessage: ''
    }
  },
  created: function () {
    this.getVariables()
  },
  watch: {
    sealMaterialFilter: function () {
      this.filterProducts()
    },
    quantities: {
      deep: true,
      handler (newValue, oldValue) {
        const rootObj = this
        rootObj.showAddToQuote = true
        rootObj.showAddToCart = true

        let quantitiesFilled = 0
        Object.keys(rootObj.quantities).forEach(function (key) {
          key = parseInt(key)
          if (parseInt(rootObj.quantities[key]) > 0) {
            quantitiesFilled++

            rootObj.products.forEach(function (product) {
              if (product.id === key) {
                if (!product.available_online) {
                  rootObj.showAddToCart = false
                }
              }
            })
          }
        })

        if (quantitiesFilled === 0) {
          rootObj.showAddToQuote = false
          rootObj.showAddToCart = false
        }
      }
    }
  },
  methods: {
    filterProducts () {
      const rootObj = this
      rootObj.showProducts = []

      if (rootObj.sealMaterialFilter === '') {
        rootObj.showProducts = rootObj.products
      } else {
        rootObj.products.forEach(function (product) {
          if (rootObj.sealMaterialFilter === product.seal_material) {
            rootObj.showProducts.push(product)
          }
        })
      }
    },
    addToQuote () {
      this.successMessage = ''
      this.errorMessage = ''

      const postData = JSON.stringify({ products: this.quantities })
      const rootObj = this

      fetch(
        '/add-to-quote',
        {
          method: 'POST',
          body: postData,
          headers: { 'Content-type': 'application/json; charset=UTF-8' }
        }
      )
        .then(response => response.json())
        .then(function (json) {
          if (json.success) {
            // reset the quantities
            Object.keys(rootObj.quantities).forEach(function (key) {
              rootObj.quantities[key] = 0
            })

            rootObj.successMessage = 'Your product(s) have been added to the quote. <a href="/quote">View Quote</a>'

            document.getElementById('quote-count').innerText = json.quoteCount
            document.getElementById('mobile-quote-count').innerText = json.quoteCount

            // scroll the user to the top
            const yOffset = -200
            const element = document.getElementById('seriesProducts')
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset
            window.scrollTo({ top: y, behavior: 'smooth' })
          } else {
            // add the error message
            if (json.errors.length > 0) {
              rootObj.errorMessage = json.errors.join('<br />')
            } else {
              rootObj.errorMessage = 'An unspecified error occurred, please try again.'
            }
          }
        })
        .catch(function (err) {
          // eslint-disable-next-line
          console.log(err)
        })
    },
    addToCart () {
      this.successMessage = ''
      this.errorMessage = ''

      const postData = JSON.stringify({ products: this.quantities })
      const rootObj = this

      fetch(
        '/add-to-cart',
        {
          method: 'POST',
          body: postData,
          headers: { 'Content-type': 'application/json; charset=UTF-8' }
        }
      )
        .then(response => response.json())
        .then(function (json) {
          if (json.success) {
          // reset the quantities
            Object.keys(rootObj.quantities).forEach(function (key) {
              rootObj.quantities[key] = 0
            })

            rootObj.successMessage = 'Your product(s) have been added to the cart. <a href="/cart">View Cart</a>'

            document.getElementById('cart-count').innerText = json.cartCount
            document.getElementById('mobile-cart-count').innerText = json.cartCount

            // scroll the user to the top
            const yOffset = -200
            const element = document.getElementById('seriesProducts')
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset
            window.scrollTo({ top: y, behavior: 'smooth' })
          } else {
            // add the error message
            if (json.errors.length > 0) {
              rootObj.errorMessage = json.errors.join('<br />')
            } else {
              rootObj.errorMessage = 'An unspecified error occurred, please try again.'
            }
          }
        })
        .catch(function (err) {
          // eslint-disable-next-line
          console.log(err)
        })
    },
    getVariables () {
      const rootObj = this

      fetch('/get-series-variables')
        .then(response => response.json())
        .then(function (json) {
          rootObj.canPurchase = json.canPurchase
        })
        .then(function () {
          rootObj.filterProducts()
        })
        .catch(function (err) {
          // eslint-disable-next-line
          console.log(err)
        })
    }
  }
}
</script>
